module.exports = __webpack_public_path__ + "img/cancun-bay-hotel.29d06dcc.jpg";